import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.document.workbench');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type Workflow = {
    key: string;
    title: string;
    label: string;
    description: string;
    output: string;
    route: string;
    tone: string;
    steps: string[];
    checklist: string[];
    inputs: string[];
};

@Component({
    selector: 'wiz-page-document-workbench',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.document.workbench/view.scss */
/* src/app/page.document.workbench/view.scss: no such file or directory */`],
})
export class PageDocumentWorkbenchComponent implements OnInit {
    public workflows: Workflow[] = [
        {
            key: 'proposal',
            title: '제안서 작성',
            label: 'Proposal',
            description: '문제 정의, 대상, 해결안, 일정, 예산, 기대효과를 갖춘 제안서 초안을 만듭니다.',
            output: '제안서 문서',
            route: '/workspace/proposal',
            tone: 'indigo',
            inputs: ['주제', '대상 기관/청중', '목표', '근거 자료', '일정/예산'],
            steps: ['요구사항 정리', '핵심 주장 설계', '목차 구성', '본문 초안 작성', '근거와 출처 점검', '제출 형식 정리'],
            checklist: ['제안 배경이 분명한가', '해결안이 실행 가능한가', '기대효과가 측정 가능한가', '표와 그림이 필요한가']
        },
        {
            key: 'proposal-slides',
            title: '제안서 기반 발표자료 작성',
            label: 'Proposal to Slides',
            description: '완성된 제안서를 발표 흐름으로 압축하고, 의사결정자가 보기 쉬운 슬라이드 구조로 바꿉니다.',
            output: '제안 발표 슬라이드',
            route: '/workspace/proposal-slides',
            tone: 'emerald',
            inputs: ['제안서 원문', '발표 시간', '청중', '핵심 의사결정', '필수 도표'],
            steps: ['제안서 핵심 문장 추출', '발표 스토리라인 구성', '슬라이드별 메시지 배치', '도표/그림 선정', '발표자 노트 작성', '질의응답 대비'],
            checklist: ['한 장에 한 메시지인가', '제안의 필요성이 앞부분에 드러나는가', '숫자와 근거가 시각화되었는가', '마지막 요청사항이 명확한가']
        },
        {
            key: 'slides',
            title: '발표자료 작성',
            label: 'Slides',
            description: '발표 목적과 청중에 맞춰 제목, 흐름, 시각자료, 발표자 노트를 포함한 발표자료를 만듭니다.',
            output: '발표자료',
            route: '/workspace/slides',
            tone: 'sky',
            inputs: ['발표 주제', '발표 시간', '청중 수준', '핵심 메시지', '이미지/도표 자료'],
            steps: ['발표 목적 정의', '슬라이드 목차 설계', '핵심 장표 작성', '시각자료 배치', '전환 문장 작성', '리허설용 노트 정리'],
            checklist: ['첫 장에서 주제가 보이는가', '슬라이드 수가 발표 시간에 맞는가', '글보다 도표가 효과적인 부분이 있는가', '마무리 메시지가 남는가']
        },
        {
            key: 'report',
            title: '보고서 작성',
            label: 'Report',
            description: '논문형 보고서, 조사 보고서, 분석 보고서를 구조화하고 출처와 결론을 갖춘 문서로 정리합니다.',
            output: '보고서 문서',
            route: '/workspace/report',
            tone: 'amber',
            inputs: ['보고서 주제', '연구 질문', '자료/논문', '사례', '요구 형식'],
            steps: ['연구 질문 정리', '자료 조사 및 출처 목록화', '목차 설계', '본문 작성', '그림/표 삽입', '인용과 참고문헌 점검'],
            checklist: ['주장이 한 문장으로 정리되는가', '본문 중간 인용이 충분한가', '사례가 국내외 균형을 갖추는가', '결론에 개인 의견이 있는가']
        }
    ];

    public selected: Workflow = this.workflows[0];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.selectFromPath();
    }

    public selectFromPath() {
        const key = location.pathname.split('/').filter(Boolean)[1] || 'proposal';
        this.selected = this.workflows.find((item) => item.key === key) || this.workflows[0];
    }

    public toneClass(tone: string) {
        switch (tone) {
            case 'emerald': return 'bg-emerald-50 text-emerald-700 border-emerald-100';
            case 'sky': return 'bg-sky-50 text-sky-700 border-sky-100';
            case 'amber': return 'bg-amber-50 text-amber-700 border-amber-100';
            default: return 'bg-indigo-50 text-indigo-700 border-indigo-100';
        }
    }

    public activeWorkflowClass(key: string) {
        if (this.selected.key === key) {
            return 'border-zinc-950 bg-zinc-950 text-white shadow-sm';
        }
        return 'border-zinc-300 bg-white text-zinc-700 hover:bg-zinc-50';
    }
}

export default PageDocumentWorkbenchComponent;